import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { FilterPageComponent } from './filter.component';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: FilterPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class FilterPageRoutingModule {}
